import React, { useEffect, useState } from "react";
import { Button } from "./ui/button";
import { Bell, BellOff, Smartphone } from "lucide-react";
import { toast } from "sonner";
import {
  isPushSupported,
  isIOSStandaloneOk,
  registerServiceWorker,
  getCurrentPushSubscription,
  subscribeToPush,
  unsubscribeFromPush,
} from "../lib/push";

export function PushSubscribeButton({ compact = false }) {
  const [subscribed, setSubscribed] = useState(false);
  const [supported, setSupported] = useState(true);
  const [iosOk, setIosOk] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        if (!isPushSupported()) {
          setSupported(false);
          setLoading(false);
          return;
        }
        if (!isIOSStandaloneOk()) {
          setIosOk(false);
        }
        await registerServiceWorker();
        const sub = await getCurrentPushSubscription();
        setSubscribed(!!sub);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const toggle = async () => {
    setLoading(true);
    try {
      if (subscribed) {
        await unsubscribeFromPush();
        setSubscribed(false);
        toast.success("Notifications désactivées");
      } else {
        await subscribeToPush();
        setSubscribed(true);
        toast.success("Notifications activées ✨");
      }
    } catch (e) {
      console.error(e);
      toast.error(e.message || "Erreur notifications");
    } finally {
      setLoading(false);
    }
  };

  if (!supported) {
    return (
      <p className="text-xs text-[#B59ED1]" data-testid="push-unsupported">
        Notifications non supportées sur ce navigateur.
      </p>
    );
  }

  if (!iosOk) {
    return (
      <div
        className="rounded-lg border border-[#00E5FF]/30 bg-[#00E5FF]/5 p-3 text-xs text-[#E2D5F8]"
        data-testid="push-ios-install-hint"
      >
        <Smartphone className="w-4 h-4 inline-block mr-1 text-[#00E5FF]" />
        Pour recevoir les notifications sur iPhone, ajoute d'abord ce site à ton
        écran d'accueil (bouton Partager dans Safari → "Sur l'écran d'accueil"),
        puis ouvre l'app et reviens ici.
      </div>
    );
  }

  return (
    <Button
      onClick={toggle}
      disabled={loading}
      variant={subscribed ? "outline" : "default"}
      size={compact ? "sm" : "default"}
      className={
        subscribed
          ? "border-[#00E5FF]/40 text-[#00E5FF] hover:bg-[#00E5FF]/10"
          : "gradient-primary"
      }
      data-testid="push-toggle-btn"
    >
      {subscribed ? (
        <>
          <BellOff className="w-4 h-4 mr-2" /> Désactiver les notifications
        </>
      ) : (
        <>
          <Bell className="w-4 h-4 mr-2" /> Activer les notifications
        </>
      )}
    </Button>
  );
}

export default PushSubscribeButton;
